<template>
  <section>
    <div class="popups">
      <b-sidebar
        v-model="showFilters"
        right
        shadow
        backdrop
        bg-variant="white"
        no-header
      >
        <template>
          <div class="container sidebar-header">
            <b-row>
              <div class="col-5">
                <b-button
                  variant="primary"
                  @click="
                    applyFilters();
                    loadItems();
                    showFilters = false;
                  "
                  >Apply</b-button
                >
              </div>

              <div class="col-7 text-right">
                <b-button
                  type="reset"
                  variant="outline-danger"
                  @click="resetFormFilters()"
                >
                  Reset
                </b-button>
                <b-button
                  variant="outline-secondary"
                  class="ml-1"
                  @click="
                    showFilters = false;
                    formFilters = { ...itemsFilters };
                  "
                >
                  Cancel
                </b-button>
              </div>
            </b-row>
          </div>

          <div class="px-3 py-2">
            <!-- <b-form-group label="Order Status:">
              <b-v-select
                v-model="formFilters.orderStatus"
                :searchable="true"
                :options="orderStatusFilter"
              />
            </b-form-group>
            <b-form-group label="Order Type:">
              <b-v-select
                v-model="formFilters.orderType"
                :searchable="true"
                :options="orderTypeFilter"
              />
            </b-form-group> -->
            <b-form-group label="Status:">
              <b-v-select
                v-model="formFilters.status"
                :searchable="true"
                :options="returnStatusOptions"
              />
            </b-form-group>
            <b-form-group label="Storefront:">
              <b-v-select
                v-model="formFilters.projectId"
                :searchable="true"
                :options="projectsList"
              />
            </b-form-group>
            <b-form-group label="Order Number:">
              <b-form-input v-model="formFilters.orderNumber" />
            </b-form-group>
            <b-form-group label="Reference Number:">
              <b-form-input v-model="formFilters.referenceNumber" />
            </b-form-group>
            <b-form-group label="Customer Name:">
              <b-form-input v-model="formFilters.name" />
            </b-form-group>

            <b-form-group
              label="From Receive Date:"
              description="From Date must be before To Date"
            >
              <b-form-datepicker
                :reset-button="true"
                v-model="formFilters.receiveDateStart"
                class="form-control flatpickr-input"
                placeholder="Select date"
                name="orderDateStart"

              />
            </b-form-group>
            <b-form-group  class="border-bottom mb-1 pb-2"  label="To Receive Date:">
              <b-form-datepicker
                :reset-button="true"
                v-model="formFilters.receiveDateEnd"
                class="form-control flatpickr-input"
                placeholder="Select date"
                name="orderDateEnd"

              />
            </b-form-group>

          </div>
        </template>
      </b-sidebar>
    </div>

    <div class="header">
      <div class="header-body">
        <div class="row align-items-end">
          <div class="col">
            <h1 class="header-title">
              Order Returns
            </h1>

            <ActiveFiltersCard :itemsFilters="itemsFilters" :resetFilterWithKey="resetFilterWithKey" :loadItems="loadItems">
              <template v-slot:filterVal(projectId)="data">
                <span
                  v-if="myProjects && myProjects.find(a => a.id == data.item)"
                  >{{ myProjects.find(a => a.id == data.item).name }}</span
                >
                <span v-else>-</span>
              </template>
              <template v-slot:filterVal(brandId)="data">
                <span
                  v-if="myBrands && myBrands.find(a => a.id == data.item)"
                  >{{ myBrands.find(a => a.id == data.item).name }}</span
                >
                <span v-else>-</span>
              </template>
              <template v-slot:filterVal(toWarehouseId)="data">
                <span
                  v-if="myWarehouses && myWarehouses.find(a => a.id == data.item)"
                  >{{ myWarehouses.find(a => a.id == data.item).name }}</span
                >
                <span v-else>-</span>
              </template>
              <template v-slot:filterVal(status)="data">
                <span
                  v-if="returnStatusOptions.find(a => a.value == data.item)"
                >{{ returnStatusOptions.find(a => a.value == data.item).label }}</span>
                <span v-else>{{ data.item }}</span>
              </template>
            </ActiveFiltersCard>
          </div>
          <div class="col-auto">
            <b-button variant="info" class="mr-1" @click="ExportPage">
              <i class="fa fa-cloud-download mr-2"></i>
              Export
            </b-button>
            <b-button variant="primary" @click="showFilters = !showFilters">
              <i class="fa fa-filter mr-2"></i>
              Filters
            </b-button>
          </div>
        </div>
      </div>
    </div>

    <TableListing
      class="mb-0"
      :loading-page="loadingItems"
      :failed-loading="failedLoadItems"
      head-variant="dark"
      :items.sync="items"
      :fields.sync="fields"
      :pagination.sync="pagination"
      :options.sync="tableOptions"
      v-on:pagination-changed="loadItems"
    >

      <template v-slot:cell(projectId)="data">
        {{ GetProjectName(data.item.projectId) }}
      </template>
      <template v-slot:cell(toWarehouseId)="data">
        <span
          v-if="myWarehouses && myWarehouses.find(a => a.id == data.item.toWarehouseId)"
          >{{ myWarehouses.find(a => a.id == data.item.toWarehouseId).name }}</span
        >
        <span v-else>-</span>
      </template>

      <template v-slot:cell(createDateTimeUtc)="data">
        <div v-if="data.item.createDateTimeUtc" class="small text-muted">Created</div>
        <div v-if="data.item.createDateTimeUtc && !data.item.createDateTimeUtc.endsWith('Z')">
          {{ (data.item.createDateTimeUtc + 'Z') | moment('MMM Do, h:mm a') }}
        </div>
        <div v-else-if="data.item.createDateTimeUtc">
          {{ data.item.createDateTimeUtc | moment('MMM Do, h:mm a') }}
        </div>
        <div v-if="data.item.receiveDate" class="small text-muted mt-1">Received</div>
        <div v-if="data.item.receiveDate && !data.item.receiveDate.endsWith('Z')">
          {{ (data.item.receiveDate + 'Z') | moment('MMM Do, h:mm a') }}
        </div>
        <div v-else-if="data.item.receiveDate">
          {{ data.item.receiveDate | moment('MMM Do, h:mm a') }}
        </div>
      </template>
      <template v-slot:cell(shipmentLabel)="data">
        <div v-if="data.item.shipmentLabel">
          <div v-if="data.item.shipmentLabel.trackingNumber">
            <span v-b-tooltip.hover title="Copy tracking number">
              <CopyText :text="data.item.shipmentLabel.trackingNumber" />
            </span>
            <a
              v-if="data.item.shipmentLabel.labelUrl"
              :href="data.item.shipmentLabel.labelUrl"
              target="_blank"
              class="btn btn-sm btn-outline-primary ml-1"
              v-b-tooltip.hover
              title="Download return label"
            >
              <i class="fa fa-file-pdf-o"></i>
            </a>
            <span
              v-if="data.item.shipmentLabel.labelUrl"
              v-b-tooltip.hover
              title="Copy return label URL"
              class="ml-1"
            >
              <CopyText :text="data.item.shipmentLabel.labelUrl">
                <i class="fa fa-link"></i>
              </CopyText>
            </span>
          </div>
        </div>
        <span v-else class="text-muted small">—</span>
      </template>
      <template v-slot:cell(referenceNum)="data">
        <div v-if="data.item.orderNumber">
          <router-link
            v-if="data.item.orderId"
            :to="{ name: 'Common.OrderDetails', query: { id: data.item.orderId } }"
            class="text-primary"
          >{{ data.item.orderNumber }}</router-link>
          <span v-else>{{ data.item.orderNumber }}</span>
        </div>
        <div class="text-muted small mt-1 border-top" v-if="data.item.referenceNum">
          <CopyText :text="data.item.referenceNum" />
        </div>
      </template>
      <template v-slot:cell(status)="data">
        <OrderReturnStatusBadge :status="data.item.status" />
      </template>
      <template v-slot:cell(id)="data">
        <router-link
          class="btn btn-info ml-1"
          :to="{
            name: 'Storefronts.OrderReturns.Edit',
            params: { orderReturnId: data.item.id }
          }"
        >
          View
        </router-link>

      </template>
    </TableListing>
  </section>
</template>

<script>
import { TableListing } from '@/views/components/custom';
import ActiveFiltersCard from '@/views/components/ActiveFiltersCard';
import OrderReturnStatusBadge from '../../../components/OrderReturnStatusBadge.vue';
import { crudMixinGen, myCommonDataMixin } from '@/helpers/utils/vueMixins.js';
import { mapGetters, mapMutations } from 'vuex';
export default {
  name: 'Storefronts.OrderReturns.Index',
  mixins: [crudMixinGen('returns'), myCommonDataMixin],
  components: {
    ActiveFiltersCard,
    TableListing,
    OrderReturnStatusBadge
  },

  data: () => ({
    returnStatusOptions: [
      { value: 'Requested', text: 'Requested' },
      { value: 'Created', text: 'Created' },
      { value: 'InTransit', text: 'In Transit' },
      { value: 'Processing', text: 'Processing' },
      { value: 'Cancelled', text: 'Cancelled' },
      { value: 'Awaiting Review', text: 'Awaiting Review' },
      { value: 'Received', text: 'Received' },
      { value: 'ReceivedDamaged', text: 'Received Damaged' }
    ],
    fields: [
      { key: 'toWarehouseId', label: 'Warehouse', sortable: false },
      { key: 'referenceNum', label: 'Ref #', sortable: false },
      { key: 'projectId', label: 'From Storefront', sortable: false },
      { key: 'status', label: 'Status', sortable: false },
      { key: 'createDateTimeUtc', label: 'Dates', sortable: false },
      { key: 'shipmentLabel', label: 'Label', sortable: false },
      { key: 'id', label: 'Action', sortable: false }
    ]
  }),

  computed: {
    ...mapGetters('manualShipments', {
      orderTypeFilter: 'getOrderTypeFilter',
      orderStatusFilter: 'getOrderStatusFilter'
    })
  },
  mounted() {
    this.loadItems();
  },

  methods: {
    ExportPage() {
      let form= document.createElement('form');
      form.setAttribute('method', 'post');
      form.setAttribute('target', '_blank');
      form.setAttribute('action', process.env.VUE_APP_API_URL + '/download/order-returns');
      var params = this.itemsFilters;
      for (var key in params) {
        var hiddenField = document.createElement('input');
        hiddenField.setAttribute('type', 'hidden');
        hiddenField.setAttribute('name', key);
        hiddenField.setAttribute('value', params[key]);
        form.appendChild(hiddenField);
      }
      document.body.appendChild(form); // Not sure if this step is necessary
      form.submit();
    },
    GetProjectName(projId) {
      let projName = '';
      let fnd = this.myProjects.find(s => s.id == projId);
      if (fnd) {
        projName = fnd.name;
      }
      return projName;
    },
    // CancelledItem(item) {
    //   this.$http
    //     .post('/api/common/orderReturns/markAsCancelled/' + item.id)
    //     .then(resp => {
    //       this.$swal('Success!', 'Order Return cancelled!', 'success');
    //     })
    //     .catch(err => {
    //       this.$swal('Error!', 'Order Return could not be marked as cancelled!', 'error');
    //     });
    // },
    ReceivedItem(item) {
      this.$http
        .post('/api/common/orderReturns/markAsReceived/' + item.id)
        .then(resp => {
          this.$swal('Success!', 'Order Return received!', 'success');
        })
        .catch(err => {
          this.$swal('Error!', 'Order Return could not be marked as received!', 'error');
        });
    }
  }
};
</script>
